import React from 'react';

import { CreateCaseRouter } from './create/CreateCaseRouter';

/**
 * CreateCase - Main entry point for create case routes
 *
 * Delegates to CreateCaseRouter which selects the appropriate
 * workflow-specific page. The router pattern allows different
 * workflows to have completely different create case implementations.
 */
export const CreateCase: React.FC = () => {
  return <CreateCaseRouter />;
};
